const schema = localStorage.getItem("schema");

export const basicFormData = () => ({
  inputData: {
    zone_name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "zone_masters",
    schema: schema,
    include: [
      {
        model: "branch_masters",
        as: "branches",
      },
    ],
  };

  const navigatePage = { back: "/zone-list" };

  const headerName = "Zone";

  const validationType = "ZoneCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

// A zone can hold many branches, so the list cell joins their names.
export const branchNames = (row) =>
  (row?.branches || [])
    .map((branch) => branch?.branch_name)
    .filter(Boolean)
    .join(", ") || "-";

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "zone_masters",
    schema: schema,
    include: [
      {
        model: "branch_masters",
        as: "branches",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Zone Name", value: "zone_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/zone-create",
    edit: "/zone-create",
    view: "/zone-view",
  };

  // Branches come back through a `separate` hasMany query when the list is
  // paginated, so their alias is not joinable here - search stays on the zone.
  const searchfields = ["zone_name"];

  const headerName = "Zone";
  const endpoint = "/getRecords";
  const exportFileName = "ZoneData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "zone_masters",
  schema: schema,
  include: [{ module: "branch_masters", moduleAs: "branches" }],
  pagination: { page: 1, pageSize: 10000 },
};
